module.exports = {
  maxWidth: 400,
  minWidth: 100,
  minHeight: 32,
  maxHeight: 200,
}
